import { Link } from 'react-router-dom';
import { useState } from 'react';

const footerLinks = {
  services: [
    { label: '短视频运营', path: '/category/short-video' },
    { label: '社交媒体营销', path: '/category/social-media' },
    { label: '创意制作', path: '/category/creative' },
    { label: '品牌传播', path: '/category/branding' },
    { label: '新媒体运营', path: '/category/new-media' },
  ],
  company: [
    { label: '关于我们', path: '/about' },
    { label: '品牌故事', path: '/about' },
    { label: '合作案例', path: '/' },
    { label: '加入我们', path: '/about' },
  ],
  support: [
    { label: '常见问题', path: '/' },
    { label: '合作咨询', path: '/about' },
    { label: '服务协议', path: '/' },
    { label: '隐私政策', path: '/' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubscribeStatus('success');
      setSubscribeMsg('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }
    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9son094ne17ei0sdl8g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMsg('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        setSubscribeStatus('error');
        setSubscribeMsg(errMsg);
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMsg('网络错误，请稍后重试');
    }
  };

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">蜜桃传媒</span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed mb-6 max-w-sm">
              蜜桃传媒是专注于优质内容创作与品牌传播的新媒体平台，汇聚创意制作、短视频运营、社交媒体营销等核心业务，助力品牌实现全域流量增长与影响力突破。
            </p>
            <div>
              <p className="text-background-100 text-sm font-medium mb-3">订阅我们的资讯</p>
              <form onSubmit={handleSubscribe} data-readdy-form="" className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="请输入您的邮箱"
                  required
                  className="flex-1 px-4 py-2.5 rounded-lg bg-background-800 text-background-100 text-sm border border-background-700 focus:outline-none focus:border-primary-500 transition-colors placeholder:text-background-500"
                />
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
                >
                  订阅
                </button>
              </form>
              {subscribeStatus !== 'idle' && (
                <p className={`text-xs mt-2 ${subscribeStatus === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
                  {subscribeMsg}
                </p>
              )}
            </div>
          </div>

          <div>
            <h4 className="text-background-100 text-sm font-semibold mb-4">核心服务</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-background-400 text-sm hover:text-background-100 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-100 text-sm font-semibold mb-4">关于我们</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-background-400 text-sm hover:text-background-100 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-100 text-sm font-semibold mb-4">帮助支持</h4>
            <ul className="space-y-3">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-background-400 text-sm hover:text-background-100 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 蜜桃传媒 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-5">
            <a href="https://weibo.com/mitaomedia" target="_blank" rel="nofollow noopener" className="text-background-400 hover:text-background-100 transition-colors">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="https://www.douyin.com/user/mitaomedia" target="_blank" rel="nofollow noopener" className="text-background-400 hover:text-background-100 transition-colors">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors">
              <i className="ri-reddit-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}